import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=8eb5eb54"
import script from "./Facets.vue?vue&type=script&lang=js"
export * from "./Facets.vue?vue&type=script&lang=js"
import style0 from "./Facets.vue?vue&type=style&index=0&id=8eb5eb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports